/**
 * WEB-392: FE mirror of the backend `TOPUP_ENABLED` flag. While top-up is off
 * (BE returns 404 «coming soon»), the UI must NOT present the packages as a live
 * money-in path — it shows them disabled with a «coming soon» note instead of a
 * click → 404 dead-end. Flips to true alongside the BE flag (WEB-121/248).
 *
 * IMPORTANT: use the literal `import.meta.env.VITE_*` access pattern — Vite's
 * static replacement only matches the literal form (mirror of stripe-pk.ts).
 */
export const TOPUP_ENABLED: boolean =
  import.meta.env.VITE_TOPUP_ENABLED === 'true';
